<div class="row">
  <div class="col-xl-4 leftOverview" [ngClass]="{ 'col-lg-12': isFreemium, 'col-md-12': isFreemium }">
    <h5 [hidden]="!data?.ivtDistribution?.sivtFraudTypes || data?.ivtDistribution?.sivtFraudTypes?.length <= 0">
      SIVT TYPES</h5>
    <ng-container *ngIf="isFreemium">
      <div class="freemium-lock">
        <i class="fa fa-lock"></i>
      </div>
    </ng-container>
    <ng-container *ngIf="!isFreemium">
      <div class="row" *ngFor="let fraudType of data?.ivtDistribution?.sivtFraudTypes">
        <div class="col-8 text-xl-right">
          <strong>{{fraudType.fraudTypeName}}</strong>
        </div>
        <div class="col">
          {{fraudType.sivtRate | perc:'1.2-2'}}
        </div>
      </div>
    </ng-container>

    <h5 [hidden]="!data?.ivtDistribution?.givtFraudTypes || data?.ivtDistribution?.givtFraudTypes?.length <= 0"
        class="mt-1">GIVT TYPES</h5>
    <ng-container *ngIf="isFreemium">
      <div class="freemium-lock mb-3">
        <i class="fa fa-lock"></i>
      </div>
    </ng-container>
    <ng-container *ngIf="!isFreemium">
      <div class="row" *ngFor="let fraudType of data?.ivtDistribution?.givtFraudTypes">
        <div class="col-8 text-xl-right">
          <strong>{{fraudType.fraudTypeName}}</strong>
        </div>
        <div class="col">
          {{fraudType.givtRate | perc:'1.2-2'}}
        </div>
      </div>
    </ng-container>
  </div>
  <div class="col-xl-8 chartContainer" *ngIf="!isFreemium && barChartData">
    <app-bar-chart [data]="barChartData"
                   [valueFields]="['givtRate']"
                   [categoryField]="'fraudTypeName'"
                   [height]="'500px'"
                   [type]="'custom'"
                   [titleArray]="['IVT']" ></app-bar-chart>
  </div>
</div>
